import { render } from "./AsSpacer.vue?vue&type=template&id=ebab9be4"
const script = {}

import "./AsSpacer.vue?vue&type=style&index=0&id=ebab9be4&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__